// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"caret-right-small","fill":"currentColor","d":"M14.9999 12L9.49988 6.5L9.49988 17.5L14.9999 12Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-caret-right-small')
export default class CaretRightSmallIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'caret-right-small',
    }
  }
}
